(function ($) {
    "use strict";
    $(document).ready(function () {
        /* Fix content apparence */
        var $cover = $('.page-cover') || null;
        if ($cover !== undefined) {
            var $pageCover = $cover.find('>img');
            var coverPath = $($pageCover).attr('src');
            var coverAlt = $($pageCover).attr('alt');
            var scrollDownBtn = $('<a class="scrolldown-btn" href="#"></a>');
            $cover.append(scrollDownBtn);

            if (coverPath !== undefined) {
                $($cover).css({
                    backgroundImage: 'url(' + coverPath + ')',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }).addClass('flex-center');

                $pageCover.remove();
            }
            if (coverAlt !== undefined) {
                $('<div class="caption flex-center justify-content-start"><h1 class="h1-responsive">' + coverAlt + '</h1></div>').appendTo($cover);
            }
        }

        /*Main color text and backgrounds */
        var $mainColor = $('[data-main-color]');

        if ($mainColor !== undefined) {
            var $clr = $mainColor.attr('data-main-color') || "#99042F";
            $('.product .left_description h1, .product .left_description h2').css({
                color: $clr
            });
            $('.product .navigation-page__body .row div:nth-child(2)').css({
                backgroundColor: $clr,
                color: 'white'
            });
            if ($('.product .navigation-page__body .row').hasClass('align-items-start')) {
                $('.product .navigation-page__body .row').removeClass('align-items-start').addClass('align-items-stretch');
            }
        }
        $('p').each(function (idx, el) {
            if ($(el).html() === '&nbsp;') {
                $(el).remove();
            }
        });
        /* Homepage product carousel slick */
        var $productHomeCarousel = $('.product-home-carousel');
        if ($productHomeCarousel !== undefined && $productHomeCarousel.length > 0) {
            $('.product-home-carousel').slick({
                mobileFirst: false,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 5,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: true,
                infinite: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }]
            });
        }
        /* EDITOR FIXES */

        /* iframe */
        var $iframeWrapper = $('iframe').closest('div');
        if ($iframeWrapper.length > 0 && $iframeWrapper !== undefined) {
            $iframeWrapper.css({
                alignSelf: 'stretch',
                minHeight: '300px'
            });
            $('iframe').css({
                position: 'absolute',
                height: '100%'
            });
        }

        /* Tables */
        var $tableResponsive = $('table');
        if ($tableResponsive !== undefined && $tableResponsive.length > 0) {
            if ($tableResponsive.attr('style')) {
                $tableResponsive.removeAttr('style');
                $tableResponsive.addClass('table');
            }
            if ($('td').attr('style')) {
                $('td, th').removeAttr('style');
                $('td, th').addClass('text-center');
            }
            $tableResponsive.wrap('<div class="table-responsive"></div>');
        }
        /* Remove the class col */
        /*if($('.col').length > 0){
            $('.col').removeClass('col');
        }*/
        /* ANIMATIONS */
        if ($('.wow').length > 0) {
            new window.WOW().init();
        }
        // SideNav Init
        $(".button-collapse").sideNav({
            edge: 'right',
            closeOnClick: true
        });

        /**
         * Masonry gallery
         */
        if ($('#masonry-gallery').length) {
            var $grid = $('#masonry-gallery').masonry({
                itemSelector: '.col-md-4',
                columnWidth: '.col-md-4',
                percentPosition: true
            });

            $grid.imagesLoaded().progress(function () {
                $grid.masonry('layout');
            });
        }

        /**
         * LIGHTBOX GALLERY
         * it should be a div#mdb-lightbox-ui and then a sibling
         * div.mdb-lightbox[.no-margin]
         * no-margin is optional
         * the ling inside the div must have data-size attribute with the same WidthxHeight size
         * of the large image.
         * Large image shouldn't be wider than 1800px
         */
        $('#mdb-lightbox-ui').load('/mdb_frt/mdb-addons/mdb-lightbox-ui.html');

        /* EVENTS */
        $('body').on('show.bs.modal', '.modal', function (e) {
            var $self = $(e.target);
            var $href = $(e.relatedTarget);
            if ($href.attr('href') !== undefined) {
                $.get($href.attr('href'), function (data) {
                    $($self).find('.modal-content').html(data);
                });
            }
            $('mdb-select').material_select();
        });
        $('body').on('shown.bs.modal', '.modal', function (e) {
            e.preventDefault();
        });
        $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal');
        });
        $('body').on('submit', '.modal form', function (e) {
            e.preventDefault();
            var self = this;
            var $hf = $(self).attr('action');
            var $data = $(self).serialize();
            $.post($hf, $data, function (result) {
                if (result.success) {
                    window.location.reload();
                } else {
                    $(self).closest('.modal-content').empty().append(result);
                }
            });
        });

        /**
         * Carousel Scrolldown-button
         */
        $('.internal-page .carousel-thumbnails').each(function(){
            var that = $(this);
            var carouselIndicators = that.find('.carousel-indicators li').length;
            if(carouselIndicators>1){
                var scrll = that.find('.scrolldown-btn') || null;
                if(scrll !== 'undefined'){
                    scrll.remove();
                }
            }
        });

        $('body').on('click', '.carousel .scrolldown-btn, .view .scrolldown-btn', function (evt) {
            evt.preventDefault();
            var target = $('#first-scroll-to');
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 'slow');
        });



        /*================================================================
        =            Custom Color in navigation internal page            =
        ================================================================*/
        var $customColorElement = $('[data-custom-color]');
        var primaryColorForGradient = $customColorElement.attr('data-custom-color');

        $('.navigation-page__body > .row-gradient').css({
            background: 'linear-gradient(#FFFFFF,' + primaryColorForGradient + ')'
        });
        // Little fix to avoid to display the border
        // in presence of an image inside
        var descriptionTitleWithGradient = $('.navigation-page__body .row-gradient .description__title');

        descriptionTitleWithGradient.each(function (index, element) {
            if ($(element).find('img').length === 0) {
                $(element).css({
                    borderBottom: '5px solid ' + primaryColorForGradient
                });
            }
        });

        $('.navigation-page__body .row:not(.row-gradient) .description__title').css({
            color: primaryColorForGradient
        });
        /*=====  End of Custom Color in navigation internal page  ======*/

        /*=====================================================================
        =            Custom Color in navigation room internal page            =
        =====================================================================*/

        $('.navigation-page.room h2,.navigation-page.room h3').css({
            color: primaryColorForGradient,
            borderBottom: '3px solid ' + primaryColorForGradient
        });
        $('.navigation-page.room .services').css({
            borderBottom: '3px solid ' + primaryColorForGradient
        });

        /*=====  End of Custom Color in navigation room internal page  ======*/


        /*===============================================
        =            Streak Fix with img tag            =
        ===============================================*/

        if ($('.streak-photo img').length > 0) {
            var streakElement = $('.streak-photo');
            var streakPhoto = null;
            if (streakElement.length === 1) {
                streakPhoto = streakElement.find('img');
                var streakPhotoPath = streakPhoto.attr('src');
                if (!!streakPhotoPath) {
                    streakElement.css({
                        backgroundImage: 'url(' + streakPhotoPath + ')'
                    });
                    streakPhoto.remove();
                }
            } else {
                streakElement.each(function (idx, element) {

                    streakPhoto = $(element).find('img');
                    var streakPhotoPath = streakPhoto.attr('src');
                    if (!!streakPhotoPath) {
                        $(element).css({
                            backgroundImage: 'url(' + streakPhotoPath + ')',
                        });
                        streakPhoto.remove();
                    }
                });
            }
        }

        /*=====  End of Streak Fix with img tag  ======*/

        /*===================================
        =            Do Carousel            =
        ===================================*/

        if ($('.do-carousel').length > 0) {
            $('.do-carousel').each(function (idx, element) {
                var carouselID = 'carousel-' + $.now();
                var carouselContainer = $('<div class="carousel slide carousel-fade" data-ride="carousel" id="' + carouselID + '"></div>');
                var carouselInnerContainer = $('<div class="carousel-inner" role="listbox"></div>');
                var carouselImages = $(element).find('img');
                var carouselIndicators = $('<ol class="carousel-indicators"></ol>');
                var carouselControls = $('<a class="carousel-control-prev" href="#' + carouselID + '" role="button" data-slide="prev"> <span class="carousel-control-prev-icon" aria-hidden="true"></span> <span class="sr-only">Previous</span> </a> <a class="carousel-control-next" href="#' + carouselID + '" role="button" data-slide="next"> <span class="carousel-control-next-icon" aria-hidden="true"></span> <span class="sr-only">Next</span> </a>');

                carouselImages.each(function (counter, image) {
                    // Indicators
                    var indicator = $('<li data-target="#' + carouselID + '" data-slide-to="' + counter + '"></li>');
                    if (!counter)  {
                        indicator.addClass('active');
                    }
                    indicator.appendTo(carouselIndicators);

                    // Images
                    var imageTag = $('<div class="carousel-item"><img src="' + $(image).attr('src') + '" class="d-block img-fluid w-100" alt="' + $(image).attr('alt') + '"/></div>');
                    if (!counter) {
                        imageTag.addClass('active');
                    }
                    imageTag.appendTo(carouselInnerContainer);
                });
                carouselIndicators.appendTo(carouselContainer);
                carouselInnerContainer.appendTo(carouselContainer);
                carouselControls.appendTo(carouselContainer);
                // Check if it's a room page
                if ($(element).closest('.room').length > 0) {
                    $('.room__title-section').after('<div class="row carousel-placeholder"><div class="col"></div></div>');
                    $('.carousel-placeholder .col').empty().append(carouselContainer);
                    $(element).remove();
                } else {
                    $(element).empty().append(carouselContainer);
                }
            });
        }

        /*=================================================================
        =            Room Master page wrapping link to details            =
        =================================================================*/

        $('.room-detail[data-room-id]').each(function (idx, element) {
            var roomId = $(this).attr('data-room-id') || null;
            var roomSlug = $(this).attr('data-room-slug') || null;
            var roomTitle = $(this).attr('data-room-title') || null;
            var roomPrice = $(this).attr('data-room-price') || null;
            var roomDisplayText = $(this).attr('data-room-display-text') || null;
            if (roomId !== null) {
                // Room Description Container
                var roomDescriptionContainer = $(this).find('.description');
                // Room Title Element
                var roomTitleContainer = $(roomDescriptionContainer).find('.description__title');

                // Compose the full url
                var roomFullUrl = "/" + roomId + "/" + roomSlug + ".html";

                // create the link
                var roomLink = $('<a href="' + roomFullUrl + '" title="' + roomTitle + '" target="_self" class="flex-center justify-content-start">' + roomTitleContainer.html() + '</a>');
                $(roomTitleContainer).html(roomLink);

                // check whether price exists
                if (roomPrice !== null) {
                    // Create the footer room description container to append buttons
                    var roomDescriptionBodyInnerContainer = $('<div class="footer pt-5 pb-3 clearfix"></div>');

                    // find the description body
                    var roomDescriptionBody = $(roomDescriptionContainer).find('.description__body');

                    // Create the element to display the price
                    var roomBtn = $('<span class="btn btn-lg btn-outline-white black-text">' + roomPrice + '</span>');

                    // Create the button to link the room view page
                    var roomDetailBtn = $('<a href="' + roomFullUrl + '" title="' + roomTitle + '" class="btn btn-lg white btn-rounded btn-outline-warning pull-right"><i class="fa fa-eye"></i> ' + roomDisplayText + '</a>');


                    // Populate the inner container with buttons
                    // roomBtn.appendTo(roomDescriptionBodyInnerContainer);
                    roomDetailBtn.appendTo(roomDescriptionBodyInnerContainer);

                    // Append the room description to the room description body element
                    roomDescriptionBodyInnerContainer.appendTo(roomDescriptionBody);
                }
            }
        });

        /*=====  End of Room Master page wrapping link to details  ======*/



        /*=====  End of Do Carousel  ======*/


        /*=========================================
        =            Date Picker Setup            =
        =========================================*/

        var alreadyReservedRoom = [];

        $.get('/booking/reservations/reserved.json').done(function (data) {
            var d = JSON.parse(data);

            // initialize disabled date until today
            alreadyReservedRoom.push({
                from: -10000,
                to: true
            });

            $(d).each(function (key, val) {
                var temp = {
                    from: [
                        val.checkin_at[0],
                        val.checkin_at[1] - 1,
                        val.checkin_at[2],
                    ],
                    to: [
                        val.checkout_at[0],
                        val.checkout_at[1] - 1,
                        val.checkout_at[2],
                    ],
                };
                alreadyReservedRoom.push(temp);
            });


            $('.datepicker').each(function (idx, element) {

                $(element).pickadate({
                    format: 'dd-mm-yyyy',
                    formatSubmit: 'yyyy-mm-dd 00:00:00',
                    hiddenName: $(element).attr('name'),
                    closeOnSelect: true,
                    closeOnClear: true,
                    disable: alreadyReservedRoom
                });
            });
        });






        /*=====  End of Date Picker Setup  ======*/


        $('#check-availability').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var href = $(this).attr('href'),
                self = $(this),
                data = self.closest('form').serialize();
            self.addClass('disabled');
            $.post(href, data, function (data) {
                self.popover('dispose');
                self.popover({
                    trigger: 'focus',
                    content: data,
                    html: true,
                    placement: 'top',
                }).popover('toggle');

                self.removeClass('disabled');
            });
        });

        /*==============================================
        =            Fixing cell form style            =
        ==============================================*/

        if ($('.btn-success').hasClass('btn-secondary')) {
            $('.btn-success').removeClass('btn-secondary');
        }

        /*=====  End of Fixing cell form style  ======*/


    });
})(jQuery);
